import { render, staticRenderFns } from "./SettingsRewards.vue?vue&type=template&id=b568b25c&scoped=true&"
import script from "./SettingsRewards.vue?vue&type=script&lang=js&"
export * from "./SettingsRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b568b25c",
  null
  
)

export default component.exports